import React from 'react';
import LOOKUP from 'constants/lookup';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Active",
        value: "1"
    },
    {
        text: "Inactive",
        value: "2"
    }
];

const searchFields = (props) => {

    props.roles.unshift({ text: "All", value: "0" });

    return (
        <section className="SearchBarContainer">
            {/*Search Inputs*/}
            <div className="row m-0">
                <div className="col-sm-6 col-md-2">
                    <SelectInput name={`${props.pageName}RoleFilter`}
                        fullWidth={true}
                        className="search-field"
                        floatingLabelText={LOOKUP.employee.filters.role.label}
                        label={LOOKUP.employee.filters.role.label}
                        hintText={LOOKUP.employee.filters.role.hintText}
                        defaultValue="0"
                        options={props.roles} />
                </div>
                <div className="col-sm-6 col-md-2">
                    <TextInput
                        name={`${props.pageName}FisrtNameFilter`}
                        className="search-field"
                        label={LOOKUP.employee.filters.firstName.label}
                        floatingLabelText={LOOKUP.employee.filters.firstName.label}
                        hintText={LOOKUP.employee.filters.firstName.hintText}
                        onPressKey={props.search} />
                </div>
                <div className="col-sm-6 col-md-2">
                    <TextInput
                        name={`${props.pageName}LastNameFilter`}
                        className="search-field"
                        label={LOOKUP.employee.filters.lastName.label}
                        floatingLabelText={LOOKUP.employee.filters.lastName.label}
                        hintText={LOOKUP.employee.filters.lastName.hintText}
                        onPressKey={props.search} />
                </div>
                <div className="col-sm-6 col-md-2">
                    <SelectInput
                        name={`${props.pageName}Status`}
                        options={statusOptions}
                        className="search-field"
                        label="Status"
                        floatingLabelText="Status"
                        defaultValue="None"
                    />
                </div>
                <div className="col-sm-6 col-md-4">
                    <SelectInput
                        name={`${props.pageName}BranchOption`}
                        className="search-field"
                        label="Branch"
                        floatingLabelText="Branch"
                        defaultValue={props.loggedBranch.toString()}
                        options={props.branchOptions} />
                </div>
            </div>
            {/*Buttons*/}
            <div className="search-buttons row m-0 mt-2">
                <Button
                    type="IconSearchButton"
                    id="ButtonSearchEmployee"
                    label={LOOKUP.employee.filters.filterButton}
                    onTouchTap={props.search}
                    className="btnNewBrandPOS pull-right mr-1" />

                <Button
                    className="btnCleanSearch"
                    type="IconClearButton"
                    label={LOOKUP.employee.filters.cleanFilterButton}
                    onTouchTap={() => props.cleanSearch()} />
            </div>
        </section>
    );
};


export default searchFields;